import { render, staticRenderFns } from "./ListAgenciesTable.vue?vue&type=template&id=0abf67a1"
import script from "./ListAgenciesTable.vue?vue&type=script&lang=ts"
export * from "./ListAgenciesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports